
const menuData = [
    {
       name: '筛查录入表',
       icon: 'qrcode',
       path: '/qrcode',
       key: 'qrcode', 
   },
   {
       name: '机构设置',
       icon: 'edit',
       path: '/institution/edit',
       key: 'institution',
   },
   {
       name: '用户管理',
       icon: 'user',
       path: '/customerList',
       key: 'customerList', 
   },
    {
        name: '统计报表',
        icon: 'area-chart',
        path: '/statistics',
        key: 'statistics', 
    },
];

export default menuData